import React from "react";

import "./aboutIndex.scss";

export class AboutIndex extends React.Component {
  public render() {
    return (
      <div className="about-index">
        {this.props.children}
      </div>
    );
  }
}
